var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.05 13.0651H8.1675C6.9375 13.0651 5.94 12.0301 5.94 10.7551C5.94 10.4476 6.195 10.1926 6.5025 10.1926C6.81 10.1926 7.065 10.4476 7.065 10.7551C7.065 11.4076 7.56 11.9401 8.1675 11.9401H10.05C10.5375 11.9401 10.9425 11.5051 10.9425 10.9801C10.9425 10.3276 10.71 10.2001 10.3275 10.0651L7.305 9.00006C6.72 8.79756 5.9325 8.36256 5.9325 7.02006C5.9325 5.86506 6.84 4.93506 7.95 4.93506H9.83249C11.0625 4.93506 12.06 5.97006 12.06 7.24506C12.06 7.55256 11.805 7.80756 11.4975 7.80756C11.19 7.80756 10.935 7.55256 10.935 7.24506C10.935 6.59256 10.44 6.06006 9.83249 6.06006H7.95C7.4625 6.06006 7.0575 6.49506 7.0575 7.02006C7.0575 7.67256 7.28999 7.80006 7.67249 7.93506L10.695 9.00006C11.28 9.20256 12.0675 9.63756 12.0675 10.9801C12.06 12.1276 11.16 13.0651 10.05 13.0651Z",
    fill: "#6E6B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.0625C8.6925 14.0625 8.4375 13.8075 8.4375 13.5V4.5C8.4375 4.1925 8.6925 3.9375 9 3.9375C9.3075 3.9375 9.5625 4.1925 9.5625 4.5V13.5C9.5625 13.8075 9.3075 14.0625 9 14.0625Z",
    fill: "#6E6B7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17.0625H6.75C2.6775 17.0625 0.9375 15.3225 0.9375 11.25V6.75C0.9375 2.6775 2.6775 0.9375 6.75 0.9375H11.25C15.3225 0.9375 17.0625 2.6775 17.0625 6.75V11.25C17.0625 15.3225 15.3225 17.0625 11.25 17.0625ZM6.75 2.0625C3.2925 2.0625 2.0625 3.2925 2.0625 6.75V11.25C2.0625 14.7075 3.2925 15.9375 6.75 15.9375H11.25C14.7075 15.9375 15.9375 14.7075 15.9375 11.25V6.75C15.9375 3.2925 14.7075 2.0625 11.25 2.0625H6.75Z",
    fill: "#6E6B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSquare);
export default __webpack_public_path__ + "static/media/dollar-square.6af6301ccc0ef22c6b8c07cea14b1c2e.svg";
export { ForwardRef as ReactComponent };